// extracted by mini-css-extract-plugin
export default {"wrapper":"EditBudget_wrapper__66XyZ","modal":"EditBudget_modal__qjv66","top":"EditBudget_top__iM6oa","edit":"EditBudget_edit__qfcrd"};